export default {
    url: "http://localhost:14100/"
};